import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import omit from 'lodash/omit';
import { getStyles, filterProps } from '../../styles/theme/index.js';
import { S } from './styles.js';
import { jsx } from '@emotion/react';
import mergeDefaultProps from '../../utils/merge-default-props.js';

var _excluded = ["children", "dataTestId", "htmlFor"];
var defaultProps = {
  tone: 'default'
};
var LabelInternal = function LabelInternal(props, ref) {
  var propsInternal = mergeDefaultProps(props, defaultProps);
  var children = propsInternal.children,
      dataTestId = propsInternal.dataTestId,
      _propsInternal$htmlFo = propsInternal.htmlFor,
      htmlFor = _propsInternal$htmlFo === void 0 ? '' : _propsInternal$htmlFo,
      rest = _objectWithoutProperties(propsInternal, _excluded);
  var containerProps = omit(rest, 'customCss');
  return jsx("label", _extends({
    ref: ref,
    css: function css(theme) {
      return [S.container(theme, propsInternal), getStyles('container', theme, propsInternal)];
    },
    "data-testid": dataTestId,
    htmlFor: htmlFor
  }, filterProps(containerProps)), children);
};
LabelInternal.displayName = 'Label';
var Label = React.forwardRef(LabelInternal);

export { Label };
//# sourceMappingURL=label.js.map
